import invariant from 'fbjs/lib/invariant.js';
import scopeLogger from '#/lib/scope-logger.js';

const console = scopeLogger('RMI:creative:validate-styles');

const wellKnownProblematicProperties = new Set([
  'aspect-ratio', // https://caniuse.com/?search=aspect-ratio

  /* mask property used for display mini player, injected with -webkit prefix */
  'mask-image', // https://caniuse.com/?search=mask-image
  'mask-size', // https://caniuse.com/?search=mask-size
  'mask-repeat', // https://caniuse.com/?search=mask-repeat
]);

export function validateStyles(schema) {
  const supportLack = [];

  schema.style.forEach(([selector, properties, media]) => {
    invariant(
      Array.isArray(properties),
      'Error reading property for %s',
      selector,
    );

    properties.forEach(([name, value]) => {
      // any value with `!important` did pass supports test
      const testValue = value?.toString().replace('!important', '');
      if (CSS.supports(name, testValue)) {
        return;
      }

      const lowSeverity = [
        // TODO: sometimes generated styles has empty values, need to
        //  - investigate why it happens
        //  - rollback commit b73773a3, 9b4b5a4a
        value === undefined,
        value === null,
        value === '',
        /*
         some properties are well known as problem, and have polyfills,
         so it should not cause the problems
        */
        wellKnownProblematicProperties.has(name),
      ].some(Boolean);

      supportLack.push({
        name,
        selector: media ? `${media}{${name}}` : selector,
        value,
        lowSeverity,
      });
    });
  });

  if (supportLack.length > 0) {
    const fatalLack = supportLack.filter(({ lowSeverity }) => !lowSeverity);
    const formSummary = (acc, { name, selector, value }) => {
      if (!(name in acc)) {
        acc[name] = [];
      }
      acc[name].push(`${selector}: '${value}'`);
      return acc;
    };
    const summary = supportLack.reduce(formSummary, {});

    if (fatalLack.length > 0) {
      const error = new Error(`CSS declaration has high severity problem`);
      error.declarations = fatalLack;
      error.status = JSON.stringify(fatalLack.reduce(formSummary, {}));
      throw error;
    } else {
      // TODO: does it make sense to track warning in kibana too?
    }

    console.groupCollapsed(
      `CSS declarations has ${supportLack.length} problem`,
    );
    console.log(JSON.stringify(summary, null, 2));
    console.groupEnd();
  }

  return schema;
}
